import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { EntityService } from "src/app/services/entity.service";
import { ReportService } from "src/app/services/report.service";
import { SharedService } from "src/app/services/sharedService";

@Component({
  selector: "app-merge-users-search",
  templateUrl: "./search-merge-users.component.html",
  styleUrls: ["./search-merge-users.component.css"],
})
export class SearchMergeUsersComponent implements OnInit {
  selectedMun = []
  
  @Output() onFilter = new EventEmitter<any>();
  @Output() onReset = new EventEmitter<any>();
  @Input() extraFields: any;
  queryFilter = {};
  panelOpenState = true;
  constructor(public entityService: EntityService, public sharedService: SharedService,
    public reportService: ReportService
  ) {}
  
  objectComparisonFunctionId = function (option, value): boolean {
    let sss = value ? option.key === value.key : false
    return sss;
  };
 
  resetFilter() {
    try {
      this.queryFilter = {}
      this.onReset.emit()
    } catch (error) {

    }


  }
  advancedSearch() {
    this.onFilter.emit(this.queryFilter)
    this.panelOpenState = false
  }

  ngOnInit() {}
}
